import { DialogV2, Typography } from '@recruit-robin/robin-theme/web-components';

import { useDictionary } from '@/shared/lib/i18n';

export const Header = () => {
  const dictionary = useDictionary();

  return (
    <DialogV2.Header>
      <Typography variant={(v) => v.heading[3]} color={(c) => c.neutral.variant[90]}>
        {dictionary.setupInterview}
      </Typography>
    </DialogV2.Header>
  );
};
